export default __webpack_public_path__ + "static/media/103t.8e7a3eec.jpg";